// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var Curry = require("rescript/lib/js/curry.js");
var React = require("react");
var Js_promise = require("rescript/lib/js/js_promise.js");
var Json_decode = require("@glennsl/bs-json/src/Json_decode.res.js");
var JsxRuntime = require("react/jsx-runtime");
var RescriptReactRouter = require("@rescript/react/src/RescriptReactRouter.res.js");
var Api$ReactHooksTemplate = require("./Api.res.js");
var Http$ReactHooksTemplate = require("../common/http.res.js");
var DataFields$ReactHooksTemplate = require("../data_fields/DataFields.res.js");
var SmsChannel$ReactHooksTemplate = require("./SmsChannel.res.js");
var EmailChannel$ReactHooksTemplate = require("./EmailChannel.res.js");
var LlmProviders$ReactHooksTemplate = require("./LlmProviders.res.js");
var SenderEmails$ReactHooksTemplate = require("./SenderEmails.res.js");
var SettingsMenu$ReactHooksTemplate = require("./SettingsMenu.res.js");
var SurveyPolicy$ReactHooksTemplate = require("./SurveyPolicy.res.js");
var SocialChannel$ReactHooksTemplate = require("./SocialChannel.res.js");
var StandardPages$ReactHooksTemplate = require("./StandardPages.res.js");
var CampaignPolicy$ReactHooksTemplate = require("./CampaignPolicy.res.js");
var EmailTemplates$ReactHooksTemplate = require("./EmailTemplates.res.js");
var TextCategories$ReactHooksTemplate = require("./TextCategories.res.js");
var RedirectionUrls$ReactHooksTemplate = require("./RedirectionUrls.res.js");
var WhatsAppChannel$ReactHooksTemplate = require("./WhatsAppChannel.res.js");
var DomainManagement$ReactHooksTemplate = require("./DomainManagement.res.js");
var EmailContentInfo$ReactHooksTemplate = require("./EmailContentInfo.res.js");
var TicketCategories$ReactHooksTemplate = require("./TicketCategories.res.js");
var NotificationRules$ReactHooksTemplate = require("./NotificationRules.res.js");
var SftpConfigurations$ReactHooksTemplate = require("./SftpConfigurations.res.js");
var HeaderFieldMappings$ReactHooksTemplate = require("./HeaderFieldMappings.res.js");
var OrganisationProfile$ReactHooksTemplate = require("./OrganisationProfile.res.js");
var OrganizationProfile$ReactHooksTemplate = require("../settings/organizationProfile.res.js");
var SurveyExclusionRule$ReactHooksTemplate = require("./SurveyExclusionRule.res.js");
var FeatureConfigurations$ReactHooksTemplate = require("./FeatureConfigurations.res.js");
var ImportEnrichmentRules$ReactHooksTemplate = require("./ImportEnrichmentRules.res.js");
var OrganizationConfigurations$ReactHooksTemplate = require("./OrganizationConfigurations.res.js");

function GeneralSettings(props) {
  var search = props.search;
  var subMenu = props.subMenu;
  var match = React.useState(function (param) {
        return false;
      });
  var setSidebarOpen = match[1];
  var match$1 = React.useState(function (param) {
        return false;
      });
  var setSidebarCollapsed = match$1[1];
  var sidebarCollapsed = match$1[0];
  var match$2 = React.useState(function (param) {
        
      });
  var setOrganizationImportEnrichmentEnabled = match$2[1];
  var organizationImportEnrichmentEnabled = match$2[0];
  React.useEffect((function (param) {
          Js_promise.$$catch((function (param) {
                  return Promise.resolve();
                }), Js_promise.then_((function (json) {
                      var organization = Json_decode.field("organization_profile", OrganizationProfile$ReactHooksTemplate.decode, json);
                      return Promise.resolve(Curry._1(setOrganizationImportEnrichmentEnabled, (function (param) {
                                        return OrganizationProfile$ReactHooksTemplate.importEnrichmentEnabled(organization);
                                      })));
                    }), Http$ReactHooksTemplate.fetchGetJSON("/api/v1/organization_profiles/1")));
        }), []);
  React.useEffect((function (param) {
          if (organizationImportEnrichmentEnabled !== undefined && !organizationImportEnrichmentEnabled && subMenu === "import_enrichment_rules") {
            RescriptReactRouter.push("/general_settings#organization_configurations");
          }
          
        }), [
        organizationImportEnrichmentEnabled,
        subMenu
      ]);
  var handleImportEnrichmentEnabledChange = function (enabled) {
    Curry._1(setOrganizationImportEnrichmentEnabled, (function (param) {
            return enabled;
          }));
  };
  var tmp;
  switch (subMenu) {
    case "API" :
        tmp = JsxRuntime.jsx(Api$ReactHooksTemplate.make, {});
        break;
    case "Email" :
        tmp = JsxRuntime.jsx(EmailChannel$ReactHooksTemplate.make, {});
        break;
    case "SMS" :
        tmp = JsxRuntime.jsx(SmsChannel$ReactHooksTemplate.make, {});
        break;
    case "Social" :
        tmp = JsxRuntime.jsx(SocialChannel$ReactHooksTemplate.make, {});
        break;
    case "WhatsApp" :
        tmp = JsxRuntime.jsx(WhatsAppChannel$ReactHooksTemplate.make, {});
        break;
    case "ai_configurations" :
        tmp = JsxRuntime.jsx(LlmProviders$ReactHooksTemplate.make, {
              search: search
            });
        break;
    case "campaign_policy" :
        tmp = JsxRuntime.jsx(CampaignPolicy$ReactHooksTemplate.make, {});
        break;
    case "data_fields" :
        tmp = JsxRuntime.jsx(DataFields$ReactHooksTemplate.make, {
              search: search
            });
        break;
    case "domain_management" :
        tmp = JsxRuntime.jsx(DomainManagement$ReactHooksTemplate.make, {});
        break;
    case "email" :
        tmp = JsxRuntime.jsx(EmailTemplates$ReactHooksTemplate.make, {});
        break;
    case "email_content_info" :
        tmp = JsxRuntime.jsx(EmailContentInfo$ReactHooksTemplate.make, {});
        break;
    case "feature_configurations" :
        tmp = JsxRuntime.jsx(FeatureConfigurations$ReactHooksTemplate.make, {});
        break;
    case "header_field_mapping" :
        tmp = JsxRuntime.jsx(HeaderFieldMappings$ReactHooksTemplate.make, {});
        break;
    case "import_enrichment_rules" :
        tmp = JsxRuntime.jsx(ImportEnrichmentRules$ReactHooksTemplate.make, {});
        break;
    case "notification_rule" :
        tmp = JsxRuntime.jsx(NotificationRules$ReactHooksTemplate.make, {
              search: search
            });
        break;
    case "organization_configurations" :
        tmp = JsxRuntime.jsx(OrganizationConfigurations$ReactHooksTemplate.make, {
              onImportEnrichmentEnabledChange: handleImportEnrichmentEnabledChange
            });
        break;
    case "organization_profile" :
        tmp = JsxRuntime.jsx(OrganisationProfile$ReactHooksTemplate.make, {});
        break;
    case "redirection_urls" :
        tmp = JsxRuntime.jsx(RedirectionUrls$ReactHooksTemplate.make, {});
        break;
    case "sFTP" :
        tmp = JsxRuntime.jsx(SftpConfigurations$ReactHooksTemplate.make, {});
        break;
    case "sender_emails" :
        tmp = JsxRuntime.jsx(SenderEmails$ReactHooksTemplate.make, {});
        break;
    case "standard_pages" :
        tmp = JsxRuntime.jsx(StandardPages$ReactHooksTemplate.make, {});
        break;
    case "survey_exclusion_rule" :
        tmp = JsxRuntime.jsx(SurveyExclusionRule$ReactHooksTemplate.make, {});
        break;
    case "survey_policy" :
        tmp = JsxRuntime.jsx(SurveyPolicy$ReactHooksTemplate.make, {});
        break;
    case "text_categories" :
        tmp = JsxRuntime.jsx(TextCategories$ReactHooksTemplate.make, {
              search: search
            });
        break;
    case "ticket_categories" :
        tmp = JsxRuntime.jsx(TicketCategories$ReactHooksTemplate.make, {});
        break;
    default:
      tmp = JsxRuntime.jsx("div", {
            children: JsxRuntime.jsxs("div", {
                  children: [
                    JsxRuntime.jsx("div", {
                          children: "⚙️",
                          className: "text-6xl mb-4"
                        }),
                    JsxRuntime.jsx("h3", {
                          children: "Select a Setting",
                          className: "text-xl font-semibold text-gray-700 mb-2"
                        }),
                    JsxRuntime.jsx("p", {
                          children: "Choose an option from the menu to get started",
                          className: "text-gray-500"
                        })
                  ],
                  className: "text-center"
                }),
            className: "flex items-center justify-center h-full"
          });
  }
  return JsxRuntime.jsxs("div", {
              children: [
                JsxRuntime.jsxs("div", {
                      children: [
                        JsxRuntime.jsx("div", {
                              children: JsxRuntime.jsx("button", {
                                    children: sidebarCollapsed ? JsxRuntime.jsx("span", {
                                            children: "☰",
                                            className: "text-xl"
                                          }) : JsxRuntime.jsxs("div", {
                                            children: [
                                              JsxRuntime.jsx("span", {
                                                    children: "Settings Menu",
                                                    className: "text-sm font-medium text-gray-700"
                                                  }),
                                              JsxRuntime.jsx("span", {
                                                    children: "◀",
                                                    className: "text-lg"
                                                  })
                                            ],
                                            className: "flex items-center justify-between w-full"
                                          }),
                                    className: "w-full flex items-center justify-center p-2 text-gray-600 hover:bg-gray-100 rounded-lg transition-colors duration-200",
                                    title: sidebarCollapsed ? "Expand sidebar" : "Collapse sidebar",
                                    onClick: (function (param) {
                                        Curry._1(setSidebarCollapsed, (function (prev) {
                                                return !prev;
                                              }));
                                      })
                                  }),
                              className: "p-4 border-b border-gray-200 flex-shrink-0"
                            }),
                        JsxRuntime.jsx("div", {
                              children: JsxRuntime.jsx(SettingsMenu$ReactHooksTemplate.make, {
                                    selectedSubMenu: subMenu,
                                    collapsed: sidebarCollapsed,
                                    organizationImportEnrichmentEnabled: organizationImportEnrichmentEnabled
                                  }),
                              className: "flex-1 overflow-y-auto"
                            })
                      ],
                      className: "hidden lg:flex bg-white border-r border-gray-200 shadow-sm transition-all duration-300 ease-in-out flex-col " + (
                        sidebarCollapsed ? "w-16" : "w-64"
                      ),
                      style: {
                        height: "calc(100vh - 5rem)"
                      }
                    }),
                JsxRuntime.jsx("div", {
                      children: JsxRuntime.jsxs("div", {
                            children: [
                              JsxRuntime.jsx("div", {
                                    children: JsxRuntime.jsxs("button", {
                                          children: [
                                            JsxRuntime.jsx("span", {
                                                  children: "☰",
                                                  className: "text-lg"
                                                }),
                                            JsxRuntime.jsx("span", {
                                                  children: "Settings Menu",
                                                  className: "text-sm font-medium"
                                                })
                                          ],
                                          className: "flex items-center space-x-2 px-4 py-2 text-gray-700 bg-gray-100 rounded-lg hover:bg-gray-200 transition-colors duration-200",
                                          onClick: (function (param) {
                                              Curry._1(setSidebarOpen, (function (prev) {
                                                      return !prev;
                                                    }));
                                            })
                                        }),
                                    className: "lg:hidden p-4 border-b border-gray-200 bg-white sticky top-0 z-10"
                                  }),
                              tmp
                            ],
                            className: "bg-white min-h-full"
                          }),
                      className: "flex-1 min-w-0 overflow-auto",
                      style: {
                        height: "calc(100vh - 5rem)"
                      }
                    }),
                match[0] ? JsxRuntime.jsxs("div", {
                        children: [
                          JsxRuntime.jsx("div", {
                                className: "fixed inset-0 bg-black bg-opacity-50 z-40 transition-opacity duration-300",
                                style: {
                                  top: "62px"
                                },
                                onClick: (function (param) {
                                    Curry._1(setSidebarOpen, (function (param) {
                                            return false;
                                          }));
                                  })
                              }),
                          JsxRuntime.jsxs("div", {
                                children: [
                                  JsxRuntime.jsxs("div", {
                                        children: [
                                          JsxRuntime.jsx("span", {
                                                children: "Settings Menu",
                                                className: "text-sm font-medium text-gray-700"
                                              }),
                                          JsxRuntime.jsx("button", {
                                                children: JsxRuntime.jsx("span", {
                                                      children: "✕",
                                                      className: "text-lg"
                                                    }),
                                                className: "p-2 text-gray-600 hover:bg-gray-100 rounded-lg transition-colors duration-200",
                                                onClick: (function (param) {
                                                    Curry._1(setSidebarOpen, (function (param) {
                                                            return false;
                                                          }));
                                                  })
                                              })
                                        ],
                                        className: "p-4 border-b border-gray-200 flex items-center justify-between flex-shrink-0"
                                      }),
                                  JsxRuntime.jsx("div", {
                                        children: JsxRuntime.jsx(SettingsMenu$ReactHooksTemplate.make, {
                                              selectedSubMenu: subMenu,
                                              collapsed: false,
                                              organizationImportEnrichmentEnabled: organizationImportEnrichmentEnabled
                                            }),
                                        className: "flex-1 overflow-y-auto"
                                      })
                                ],
                                className: "fixed left-0 bottom-0 w-64 bg-white shadow-xl z-50 transform transition-transform duration-300 ease-in-out flex flex-col",
                                style: {
                                  top: "62px"
                                }
                              })
                        ],
                        className: "lg:hidden"
                      }) : null
              ],
              className: "flex h-screen bg-gray-50"
            });
}

var make = GeneralSettings;

exports.make = make;
/* react Not a pure module */
